export const handleError = (err) => {
    return {...err?.error, error: err?.error || err?.data, code: err?.status || 400}
}

export const getApiErrorMessage = (errorPayload) => {
    if (!errorPayload) {
        return "Unknown error, please try again later.";
    }

    if (typeof errorPayload === "string") {
        return errorPayload;
    }

    const apiError = errorPayload?.error ?? errorPayload;

    if (typeof apiError === "string") {
        return apiError;
    }

    if (apiError?.message) {
        return String(apiError.message);
    }

    if (errorPayload?.message) {
        return String(errorPayload.message);
    }

    if (errorPayload?.code) {
        return `Request failed (${errorPayload.code}).`;
    }

    return "Unknown error, please try again later.";
}